<div #outComponent class="out">
</div>